import { getAccessToken } from './sessionToken.ts'
import { isGuestSession } from './sessionGuest.ts'

export const hasStoredAuthenticatedSession = (): boolean => {
  const accessToken = getAccessToken()
  return Boolean(accessToken && !isGuestSession())
}
